<template>
  <b-modal id="message-box" size="sm" hide-header hide-footer>
    <p class="my-2 text-center">{{ $t('security.messageBox.text') }}</p>
  </b-modal>
</template>

<script>

export default {
  name: 'SubMessageBox',
  mounted(){
   this.showModal()
  },
  methods:{
    showModal(){
      this.$bvModal.show('message-box')
    },
    hideModal(){
      this.$bvModal.hide('message-box')
    }
  }
}
</script>
